import React from 'react';
import styled from 'styled-components';
import { useValidationControl, ValidationControlProps } from 'src/shared/validation';
import ValidationMessage from './validationMessage';

export interface ValidationBoxProps<TValue = unknown> extends ValidationControlProps<TValue> {
    children?: React.ReactNode;
    className?: string;
    fullWidth?: boolean;
}

const ValidationBoxContainer = styled.div<{ $isError?: boolean; $fullWidth?: boolean }>`
    display: ${(props) => (props.$fullWidth ? 'block' : 'inline-block')};
    width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
    max-width: 100%;
    padding: 4px;
    margin: -4px;
    box-sizing: border-box;
    border: 1px solid transparent;
    border-radius: 4px;

    ${(props) => props.$isError && 'border-color: #DE1C22;'}
    ${(props) => props.$isError && 'box-shadow: 0 0 0 2px rgba(222, 28, 34, 0.2);'}
`;

const ValidationBoxWrapper = styled.div<{ $fullWidth?: boolean }>`
    display: ${(props) => (props.$fullWidth ? 'flex' : 'inline-flex')};
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
    max-width: 100%;
`;

export const ValidationBox = <TValue,>(props: ValidationBoxProps<TValue>) => {
    const { children, className, fullWidth, validationKey, validate, validationMessage, message, validationLabel, validationValue } = props;
    const validation = useValidationControl<HTMLDivElement, TValue>(
        { validationKey, validate, validationMessage: validationMessage ?? message, validationLabel, validationValue },
        validationValue as TValue
    );

    return (
        <ValidationBoxWrapper className={className} $fullWidth={fullWidth}>
            <ValidationBoxContainer ref={validation.setRef} $isError={validation.isValidationError} $fullWidth={fullWidth}>
                {children}
            </ValidationBoxContainer>
            {validation.validationKey && <ValidationMessage validationKey={validation.validationKey} deferUntilSubmit />}
        </ValidationBoxWrapper>
    );
};
